import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Box, Grid2 } from "@mui/material";

const basico = [
  { titulo: "Duración", descripcion: "6 meses, 120 horas" },
  {
    titulo: "Gramática",
    descripcion:
      "Verbos auxiliares, partes de una oración, conjugaciones y tiempos de los verbos.",
  },
  {
    titulo: "Objetivo",
    descripcion:
      "Ayudar al alumno a leer artículos de revistas y periódicos y a hablar claramente",
  },
  {
    titulo: "Actividades",
    descripcion:
      "Repaso de la gramática elemental, ejercicios de lectura y de escritura",
  },
];

const intermedio = [
  { titulo: "Duración", descripcion: " 6 meses, 120 horas" },
  {
    titulo: "Gramática",
    descripcion:
      "Adjetivos, adverbios, gerundios, infinitivos, oraciones compuestas, sujetos y objetos.",
  },
  {
    titulo: "Objetivo",
    descripcion:
      "Alcanzar una fluidez aceptable al hablar, escribir y expresar ideas, el alumno podrá leer información de páginas web, y documentos de un lenguaje semi-profesional.",
  },
  {
    titulo: "Actividades",
    descripcion: "Gramática compleja, escritura de cartas, ensayos y reportes.",
  },
];

const avanzado = [
  { titulo: "Duración", descripcion: "6 meses, 120 horas" },
  {
    titulo: "Gramática",
    descripcion:
      "Combinaciones de tiempos, la voz pasiva, verbos frase, cláusulas y oraciones compuestas. Combinaciones de verbos, voces pasivas y el participio pasivo",
  },
  {
    titulo: "Objetivo",
    descripcion:
      "Mejorar la pronunciación, expandir el vocabulario de cada estudiante de acuerdo a su profesión",
  },
  {
    titulo: "Actividades",
    descripcion:
      "Poco estudio de gramática, mayor énfasis en conversación y expresión Mayor énfasis en conversación, expresión más adecuada tanto oral como escrita.",
  },
];

const Niveles = () => {
  return (
    <Box>
      <Box sx={{ padding: "20px 0" }}>
        <Grid2 container spacing={0}>
          <Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
            <Box
              sx={{
                background: "#009999",
                height: "100%",
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <b>NIVEL BÁSICO</b>
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 10 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  {basico.map((row, index) => (
                    <TableRow key={index} sx={{ border: "2px solid #009999" }}>
                      <TableCell align="center">
                        <b>{row.titulo}</b>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ borderLeft: "1px solid black" }}
                      >
                        {row.descripcion}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid2>
        </Grid2>
      </Box>

      <Box sx={{ padding: "20px 0" }}>
        <Grid2 container spacing={0}>
          <Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
            <Box
              sx={{
                background: "#009999",
                height: "100%",
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <b>NIVEL INTERMEDIO</b>
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 10 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  {intermedio.map((row, index) => (
                    <TableRow key={index} sx={{ border: "2px solid #009999" }}>
                      <TableCell align="center">
                        <b>{row.titulo}</b>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ borderLeft: "1px solid black" }}
                      >
                        {row.descripcion}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid2>
        </Grid2>
      </Box>

      <Box sx={{ padding: "20px 0" }}>
        <Grid2 container spacing={0}>
          <Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
            <Box
              sx={{
                background: "#009999",
                height: "100%",
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <b>NIVEL AVANZADO</b>
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 10 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  {avanzado.map((row, index) => (
                    <TableRow key={index} sx={{ border: "2px solid #009999" }}>
                      <TableCell align="center">
                        <b>{row.titulo}</b>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ borderLeft: "1px solid black" }}
                      >
                        {row.descripcion}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
};

export default Niveles;
